import React, { useState } from 'react'

import { toggleModal as toggleModalAction } from 'redux/active/actions'
import { useActions, useAppSelector } from 'redux/hooks'

import { CardType } from 'types/deck'
import { FileType, FileTypeOption } from './types'

import PhatDropdown from 'components/formElements/PhatDropdown'
import GlobalOverlayStack from 'components/elements/Overlay/GlobalOverlayStack'
import SelectMultipleCards from 'components/formElements/SelectMultipleCards'

// Importer components
import TextFile from './TextFile'
import CSVFile from './CSVFile'
import Arena from './Arena'
import MTGO from './MTGO'
import PDFFile from './PDFFile'
import EDHREC from './EDHREC'

import styles from './export.module.scss'

const fileTypeOptions: FileTypeOption[] = [
  { label: 'Text', value: 'txt', component: TextFile },
  { label: 'CSV', value: 'csv', component: CSVFile },
  { label: 'Arena', value: 'arena', component: Arena },
  { label: 'MTGO.dek', value: 'dek', component: MTGO },
  { label: 'Deck Registration PDF', value: 'pdf', component: PDFFile },
  { label: 'EDHREC Article', value: 'edhrec', component: EDHREC },
]

const ExportModal = () => {
  const exportActive = useAppSelector(state => state.active.modals.export)

  const [toggleModal] = useActions(toggleModalAction)

  return (
    <GlobalOverlayStack open={exportActive} onClose={() => toggleModal('export', false)} className={styles.container}>
      <ExportOverlayContent />
    </GlobalOverlayStack>
  )
}

export default ExportModal

export const ExportOverlayContent = () => {
  const [fileType, setFileType] = useState<FileType>('txt')
  const [selectedCards, setSelectedCards] = useState(new Array<CardType>())

  const deckName = useAppSelector(state => state.deck.name)
  const categories = useAppSelector(state => state.deck.categories)

  const ExportForm = fileTypeOptions.find(option => option.value === fileType)?.component || TextFile

  return (
    <div className={styles.content}>
      <h3> Export {deckName}</h3>

      <SelectMultipleCards
        onChange={setSelectedCards}
        className={styles.cardSelector}
        includeOutOfDeckAsDefault={fileType === 'txt' || fileType === 'csv'}
      />

      <PhatDropdown
        inlineHeader
        header="Export type"
        value={fileType}
        triggerWrapperClassName={styles.fileTypeDropdown}
        options={fileTypeOptions.map(option => ({
          label: option.label,
          id: option.value,
          onClick: () => setFileType(option.value),
        }))}
      />

      <ExportForm selectedCards={selectedCards} categoryMap={categories} fileName={deckName} />
    </div>
  )
}
